import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireRole } from "@/lib/auth";
import { PublicLayout } from "@/components/site";
import { AuthCallback } from "@/components/google";
import Home from "@/pages/Home";
import Results from "@/pages/Results";
import { Consultation, Refer, RefCode, Legal } from "@/pages/PublicForms";
import { LoginPage, RegisterPage, ForgotPage, ResetPage, VerifyPage } from "@/pages/Auth";
import Portal from "@/pages/Portal";
import Owner from "@/pages/Owner";

const qc = new QueryClient({ defaultOptions: { queries: { staleTime: 60000, refetchOnWindowFocus: false } } });

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/results" element={<Results />} />
        <Route path="/consultation" element={<Consultation />} />
        <Route path="/refer" element={<Refer />} />
        <Route path="/privacy" element={<Legal slug="privacy" />} />
        <Route path="/terms" element={<Legal slug="terms" />} />
      </Route>
      <Route path="/r/:code" element={<RefCode />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/owner/login" element={<LoginPage owner />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPage />} />
      <Route path="/reset-password" element={<ResetPage />} />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/portal/*" element={<RequireRole roles={["client"]} loginPath="/login"><Portal /></RequireRole>} />
      <Route path="/owner/*" element={<RequireRole roles={["owner", "staff"]} loginPath="/owner/login"><Owner /></RequireRole>} />
      <Route path="*" element={<PublicLayout />}><Route path="*" element={<Home />} /></Route>
    </Routes>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0, fontFamily: "Inter" } }} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
